export class MaintenanceTaskCompletionDTO {
  taskId: number = 0;
  userId: number = 1;
  date: string = '';
}
